module.exports = __webpack_public_path__ + "img/color_block_7.d375c35f.svg";